// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ps-c";
export var backButton = "_ps-4";
export var backIcon = "_ps-5";
export var chevronShortcut = "_ps-6";
export var container = "_ps-1";
export var editor = "_ps-8";
export var editorWrapper = "_ps-7";
export var prefix = "_ps-2";
export var searchIcon = "_ps-3";
export var suffix = "_ps-9";
export var suffixContent = "_ps-a";
export var suffixText = "_ps-b";
export var wrapper = "_ps-0";